/*
 * File: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice\src\Content\CollapseBox\CollapseBox.tsx
 * Project: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice
 * Created Date: Thursday October 12th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Thursday October 12th 2023 3:12:35 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */

import { useState } from "react";
import { Collapse } from 'react-collapse';
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from "react-icons/md";
import Styles from "Content/CollapseBox/CollapseBox.module.css";

type CollapseBoxProps = {
    children: JSX.Element,
    textBtn: string,
    class?: string,
}

function CollapseBox(props: CollapseBoxProps) {
    const [showMe, setShowMe] = useState(false);

    return (
        <div className={props.class}>
            <button className={`${Styles.collapseBtn}`} onClick={() => setShowMe(!showMe)}>
                {props.textBtn}
                {showMe ? <MdKeyboardArrowUp/> : <MdKeyboardArrowDown/>}
            </button>
            <Collapse isOpened={showMe} initialStyle={{height:"auto"}}>
                {
                    showMe ?
                    props.children
                    :null
                }
            </Collapse>
        </div>
    )
}

export default CollapseBox;
